import { CITYCOORDS } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppNoApiAction, AppAction, BaseAsyncReducerState } from "../../types";

export interface CityResponse extends BaseAsyncReducerState {
    results: Record<string, unknown>;
}

// Define an initial state value for the app
const initialState: CityResponse  = {
    loading: false,
    error: false,
    results: {}
}


function CityReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case CITYCOORDS.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case CITYCOORDS.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false

            }
        case CITYCOORDS.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case CITYCOORDS.RESET:
            return {
                ...state,
                loading: false,
                error: payload,
                results: {}
            };
        default:
            return state
        }
}

export default CityReducer;